import type { CSSProperties } from 'react'
import { useTheme } from '@/components/theme/theme-provider'
import { Toaster } from '@/components/ui/sonner'

/**
 * The app's one toast system: sonner, dressed as the console design's `.toast`
 * (dark-on-light in light, light-on-dark in dark), bottom centre, 22px up. The
 * look is `.toast` in styles/console.css; the layout fix is in index.css.
 * Call `toast('…')` from 'sonner'.
 */
export function AppToaster() {
  const { resolvedTheme } = useTheme()
  return (
    <Toaster
      theme={resolvedTheme}
      position="bottom-center"
      offset={22}
      mobileOffset={22}
      style={{ '--width': '440px' } as CSSProperties}
      toastOptions={{ unstyled: true, classNames: { toast: 'toast' } }}
    />
  )
}
